const INVALID_LABEL_MESSAGE =
  'The return label could not be opened. Please contact ShipAid support.';

const labelBlob = (dataUrl: string): Blob => {
  const commaIndex = dataUrl.indexOf(',');
  if (commaIndex === -1) throw new Error(INVALID_LABEL_MESSAGE);

  const metadata = dataUrl.slice(5, commaIndex).toLowerCase().split(';');
  const contentType = metadata[0];
  if (!/^(application\/(pdf|octet-stream)|image\/(png|jpeg|gif|webp))$/.test(contentType)) {
    throw new Error(INVALID_LABEL_MESSAGE);
  }

  try {
    const rawPayload = dataUrl.slice(commaIndex + 1);
    const isBase64 = metadata.includes('base64');
    const payload = isBase64 && !rawPayload.includes('%')
      ? rawPayload
      : decodeURIComponent(rawPayload);
    if (!payload) throw new Error(INVALID_LABEL_MESSAGE);
    let content: Uint8Array | string = payload;
    if (isBase64) {
      const binary = atob(payload);
      const bytes = new Uint8Array(binary.length);
      for (let index = 0; index < binary.length; index++) {
        bytes[index] = binary.charCodeAt(index);
      }
      content = bytes;
    }
    return new Blob([content], { type: contentType });
  } catch {
    throw new Error(INVALID_LABEL_MESSAGE);
  }
};

export const openReturnLabel = (labelUrl: string): void => {
  const url = labelUrl.trim();
  const blob = /^data:/i.test(url) ? labelBlob(url) : null;
  if (!blob && !/^https?:\/\//i.test(url)) {
    throw new Error(INVALID_LABEL_MESSAGE);
  }

  const objectUrl = blob ? URL.createObjectURL(blob) : null;
  let labelWindow: Window | null = null;
  try {
    // Keep the popup in the click event and detach its opener before navigating.
    labelWindow = window.open('', '_blank');
    if (!labelWindow) {
      throw new Error(
        'Allow pop-ups for ShipAid, then try opening the return label again.',
      );
    }
    labelWindow.opener = null;
    labelWindow.location.replace(objectUrl || url);
  } catch (error) {
    labelWindow?.close();
    if (objectUrl) URL.revokeObjectURL(objectUrl);
    throw error;
  }

  if (objectUrl) {
    // The PDF viewer must finish consuming the URL before it is released.
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
  }
};
